import { CmsConverterService } from '../../../cms/services/cms-converter/cms-converter.service'
import { CmsComponent } from '@spartacus/core'
import { TrainingObjectivesComponentData } from './index'
import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class TrainingObjectivesConverter extends CmsConverterService<TrainingObjectivesComponentData> {

  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      trainingId: formData.st_training_id?.value,
    }
  }
}
